import useClientMutation from '../../common/useClientMutation';
import { ALERTS_REGISTERED_URL } from '../../consts';
const resourceType = 'newsletter';
export default function useNewsletterSignupPersonal() {
    const searchParams = new URLSearchParams({
        resourceType
    });
    return useClientMutation({
        cacheKey: 'newsletterSignupPersonal',
        url: ALERTS_REGISTERED_URL,
        searchParams,
        fetchOptions: {
            method: 'GET'
        },
        clientOptions: {
            useErrorBoundary: false,
            cacheTime: 0,
            retry: false
        }
    });
}

//# sourceMappingURL=useNewsletterSignupPersonal.js.map